class NeltumeMadeToOrderNotice extends HTMLElement {
  connectedCallback() {
    this.closestSection = this.closest('.shopify-section, dialog');
    this.closestSection?.addEventListener('variant:update', this.updateNotice);
  }

  disconnectedCallback() {
    this.closestSection?.removeEventListener('variant:update', this.updateNotice);
  }

  updateNotice = (event) => {
    if (event.detail?.data?.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else {
      const eventProductId =
        event.detail?.data?.productId || (event.target instanceof HTMLElement ? event.target.dataset.productId : '');

      if (eventProductId && this.dataset.productId && eventProductId !== this.dataset.productId) return;
    }

    const updatedNotice = event.detail?.data?.html?.querySelector(
      `neltume-made-to-order-notice[data-block-id="${this.dataset.blockId}"]`
    );

    if (!updatedNotice) return;

    this.className = updatedNotice.className;
    this.innerHTML = updatedNotice.innerHTML;
    this.dataset.visible = updatedNotice.dataset.visible || 'false';
    this.setAttribute('aria-hidden', updatedNotice.getAttribute('aria-hidden') || 'true');

    if (updatedNotice.dataset.productId) {
      this.dataset.productId = updatedNotice.dataset.productId;
    }
  };
}

if (!customElements.get('neltume-made-to-order-notice')) {
  customElements.define('neltume-made-to-order-notice', NeltumeMadeToOrderNotice);
}
